<template>

    <div class="col-lg-9 col-md-9 col-xs-12 product-info">
        <h3>{{ title }}</h3>
        <slot name="description"></slot>
    </div>

</template>
<script>
    export default {
        props: ['title']
    }
</script>



// WEBPACK FOOTER //
// product.vue?470e9890